import { IProps } from "./types/IProps"
import { useAppSelector } from "../../hooks/store-hooks"
import { useLocalStorageService } from "../../../use-cases/local-storage"
import { useAuthService } from "../../../use-cases/auth"
import { useEffect, useRef, useState } from "react"
import { useAppDispatch } from "../../hooks/store-hooks"

export const PrivateRoute = (props: IProps) => {
  const isValid = useAppSelector((state) => state.auth.isValid)
  const token = useAppSelector((state) => state.auth.token)
  const { getItem } = useLocalStorageService()
  const { setupSession } = useAuthService()
  const [isInitializing, setIsInitializing] = useState(true)
  const hasTriedRestore = useRef(false)
  const dispatch = useAppDispatch()

  // Restaurar sessão quando há token no localStorage mas não no Redux (ex.: F5 em /modulos)
  useEffect(() => {
    const tokenStorage = getItem({
      key: 'ACCESS_TOKEN'
    })

    if (isValid && token && token !== 'not_valid' && token !== '') {
      setIsInitializing(false)
      return
    }

    if (tokenStorage && tokenStorage !== '' && (!token || token === 'not_valid')) {
      if (!hasTriedRestore.current) {
        hasTriedRestore.current = true
        setupSession().finally(() => {
          setIsInitializing(false)
        })
        return
      }
    }

    setIsInitializing(false)
  }, [token, isValid, getItem, setupSession, dispatch])
  
  const tokenFromStorage = getItem({ key: 'ACCESS_TOKEN' })
  const hasValidToken = Boolean(
    (isValid && token && token !== '' && token !== 'not_valid') ||
    (tokenFromStorage && tokenFromStorage !== '' && tokenFromStorage !== 'not_valid')
  )

  useEffect(() => {
    if (!isInitializing && !hasValidToken) {
      let loginUrl = String(process.env.REACT_APP_VELES_APP_URL_LOGIN)
      if (!loginUrl.includes('/authentication/login')) {
        loginUrl = loginUrl.replace('/auth/login', '/authentication/login')
      }
      const appBaseUrl = loginUrl.replace('/authentication/login', '').replace('/auth/login', '')
      window.localStorage.clear()
      window.sessionStorage.clear()
      window.location.href = `${appBaseUrl}/authentication/login?logout=true`
    }
  }, [isInitializing, hasValidToken])
  
  if (isInitializing && tokenFromStorage && tokenFromStorage !== '' && tokenFromStorage !== 'not_valid') {
    return <>{props.children}</>
  }
  
  return (
    <>
      {
        hasValidToken ? (
          <>
            {props.children}
          </>
        ) : null
      }
    </>
  )
}